/* ARO Theme - Shopify JavaScript */

class AROTheme {
  constructor() {
    this.init();
  }

  init() {
    this.initCart();
    this.initScrollEffects();
    this.initQuickAdd();
    this.initQuantitySelectors();
    this.initAnimations();
  }

  initCart() {
    // Cart drawer toggle
    const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const cartClose = document.querySelector('[data-cart-close]');

    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        cartDrawer?.classList.add('open');
        cartOverlay?.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });

    cartClose?.addEventListener('click', () => this.closeCart());
    cartOverlay?.addEventListener('click', () => this.closeCart());

    // Update cart count
    this.updateCartCount();
  }

  closeCart() {
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countElements = document.querySelectorAll('[data-cart-count]');
      countElements.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  initScrollEffects() {
    const navbar = document.querySelector('.site-header');

    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        navbar?.style.setProperty('box-shadow', '0 2px 20px rgba(0,0,0,0.08)');
      } else {
        navbar?.style.setProperty('box-shadow', 'none');
      }
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.textContent = 'Adding...';
        button.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (response.ok) {
            button.textContent = 'Added!';
            this.updateCartCount();

            // Show cart drawer
            const cartDrawer = document.querySelector('[data-cart-drawer]');
            const cartOverlay = document.querySelector('[data-cart-overlay]');
            cartDrawer?.classList.add('open');
            cartOverlay?.classList.add('open');
            document.body.style.overflow = 'hidden';

            setTimeout(() => {
              button.textContent = 'Quick Add';
              button.disabled = false;
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = 'Quick Add';
            button.disabled = false;
          }, 2000);
        }
      });
    });
  }

  initQuantitySelectors() {
    document.querySelectorAll('[data-quantity]').forEach(container => {
      const minus = container.querySelector('[data-quantity-minus]');
      const plus = container.querySelector('[data-quantity-plus]');
      const input = container.querySelector('[data-quantity-input]');

      minus?.addEventListener('click', () => {
        const current = parseInt(input.value) || 1;
        if (current > 1) {
          input.value = current - 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      plus?.addEventListener('click', () => {
        const current = parseInt(input.value) || 1;
        input.value = current + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  initAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.product-card, .community-card, .editorial-content').forEach(el => {
      observer.observe(el);
    });
  }
}

// Initialize theme
document.addEventListener('DOMContentLoaded', () => {
  new AROTheme();
});

// Shopify cart update handler
document.addEventListener('cart:updated', () => {
  const theme = new AROTheme();
  theme.updateCartCount();
});
